"use client";

// Thin client wrapper so we can use dynamic({ ssr: false }) for AndroidInstallPrompt.
// next/dynamic with ssr:false is only allowed in Client Components.
import dynamic from "next/dynamic";

const AndroidInstallPrompt = dynamic(() => import("./android-install-prompt"), { ssr: false });

export default function AndroidInstallPromptClient() {
  return <AndroidInstallPrompt />;
}
